import { Column } from "@tanstack/react-table";
import { ChangeEvent } from "react";
import Form from "react-bootstrap/Form";

type TextInputFilterProps<T> = {
    column: Column<T, unknown>;
};

export const TextInputFilter = <T extends object>(props: TextInputFilterProps<T>) => {
    const { column } = props;

    const filterValue = column.getFilterValue() as string;

    const onChangeFilter = (event: ChangeEvent<HTMLInputElement>) => {
        column.setFilterValue(event.target.value || undefined)
    };

    const placeholderText = column.columnDef.header as string;

    return (
        <Form.Control
            id={`${column.id}-filter`}
            value={filterValue || ''}
            onChange={onChangeFilter}
            placeholder={placeholderText}
            data-lpignore="true"
            autoComplete="off"
        />
    );
};